(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_search-input"] && !Shopify.designMode) return;
  try {
    (function () {
    var DELAY = 300; /* пауза после последней буквы, в миллисекундах */
    var MIN_LENGTH = 2; /* с какого количества символов начинать поиск */

    var form = document.querySelector('form[data-albasty-live-search]');
    if (!form) return;

    var input = form.querySelector('input[name="q"]');
    var clearButton = form.querySelector('[data-albasty-search-clear]');
    var resultsList = document.querySelector('results-list[section-id]');
    if (!input || !resultsList) return;

    var sectionId = resultsList.getAttribute('section-id');
    var timer = null;
    var controller = null;
    var lastQuery = input.value.trim();

    /* Курсор в конец текста, если страница открылась с уже введённым запросом */
    if (input.value) {
      var end = input.value.length;
      try {
        input.setSelectionRange(end, end);
      } catch (e) {}
    }

    function buildParams(query) {
      var params = new URLSearchParams();
      if (query) {
        params.set('q', query);
        params.set('type', 'product');
        params.set('options[prefix]', 'last');
      }
      return params;
    }

    function getSection() {
      return document.getElementById('shopify-section-' + sectionId);
    }

    function runSearch(query) {
      if (query === lastQuery) return;
      lastQuery = query;

      if (controller) controller.abort();
      controller = typeof AbortController === 'function' ? new AbortController() : null;

      var params = buildParams(query);
      var pageUrl = form.getAttribute('action') + (query ? '?' + params.toString() : '');
      params.set('section_id', sectionId);
      var fetchUrl = form.getAttribute('action') + '?' + params.toString();

      var section = getSection();
      if (section) section.classList.add('albasty-search-loading');

      fetch(fetchUrl, controller ? { signal: controller.signal } : {})
        .then(function (response) {
          if (!response.ok) throw new Error('Search request failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          if (query !== lastQuery) return; /* пока ждали ответ, человек уже ввёл другое */

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + sectionId);
          var current = getSection();
          if (!fresh || !current) {
            window.location.href = pageUrl;
            return;
          }

          current.innerHTML = fresh.innerHTML;
          current.classList.remove('albasty-search-loading');
          window.history.replaceState(window.history.state, '', pageUrl);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          /* Если что-то пошло не так — обычный поиск с перезагрузкой, как запасной вариант */
          window.location.href = pageUrl;
        });
    }

    function scheduleSearch() {
      clearTimeout(timer);
      var query = input.value.trim();
      if (query.length > 0 && query.length < MIN_LENGTH) return;
      timer = setTimeout(function () {
        runSearch(query);
      }, DELAY);
    }

    input.addEventListener('input', scheduleSearch);

    /* Enter или кнопка «Найти» на клавиатуре телефона: ищем сразу и прячем клавиатуру */
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearTimeout(timer);
      var query = input.value.trim();
      if (query.length > 0 && query.length < MIN_LENGTH) return;
      runSearch(query);
      input.blur();
    });

    function clearSearch() {
      clearTimeout(timer);
      input.value = '';
      input.focus();
      runSearch('');
    }

    if (clearButton) clearButton.addEventListener('click', clearSearch);

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && input.value) {
        event.preventDefault();
        clearSearch();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["preorder-button"] && !Shopify.designMode) return;
  try {
    function albastyOpenPreorderMessage() {
    document.querySelectorAll('dialog.preorder-dialog').forEach(function (dialog) {
      if (dialog.querySelector('[data-preorder-open]') && !dialog.open) {
        dialog.showModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', albastyOpenPreorderMessage);
  } else {
    albastyOpenPreorderMessage();
  }

  /* Проверка полей ДО капчи.
     Защита Shopify от ботов (hCaptcha) перехватывает отправку формы и отправляет её в обход
     проверки браузера. Поэтому проверяем поля сами, раньше капчи: если что-то заполнено
     неправильно — отправку останавливаем и браузер подсвечивает ошибочное поле. */
  function albastyPreorderBlockInvalid(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var form = event.type === 'submit' ? target : target.closest('form');
    if (!form || !form.classList || !form.classList.contains('preorder-form')) return;
    if (event.type === 'click' && !target.closest('[type="submit"]')) return;

    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.reportValidity();
    }
  }

  window.addEventListener('click', albastyPreorderBlockInvalid, true);
  window.addEventListener('submit', albastyPreorderBlockInvalid, true);

  /* Поле телефона: буквы и другие лишние символы не вводятся вообще.
     Разрешены цифры, пробелы, скобки, дефисы и один знак + в самом начале. */
  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('.preorder-form input[type="tel"]')) return;

    var cleaned = input.value.replace(/[^\d\s()+\-]/g, '');
    var startsWithPlus = cleaned.trim().charAt(0) === '+';
    cleaned = cleaned.replace(/\+/g, '');
    if (startsWithPlus) cleaned = '+' + cleaned.replace(/^\s+/, '');

    if (cleaned !== input.value) input.value = cleaned;
  });
  } catch(e) { console.error(e); }
})();

})();
